var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',[_vm._v(" Employee Record "),_c('v-container',[_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"label":"ID"}})],1),_c('v-col',[_c('v-text-field',{attrs:{"label":"First Name"}})],1),_c('v-col',[_c('v-text-field',{attrs:{"label":"Last Name"}})],1),_c('v-col',[_c('v-btn',[_vm._v(" Search ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }